module.exports = __webpack_public_path__ + "img/text_apply.b3ea7a4a.png";